export {
  GatedRecentlyViewed,
  RECENTLY_VIEWED_MAX_PRODUCTS,
} from './GatedRecentlyViewed';
export { isRecentlyViewedAllowed } from './recentlyViewedRoutes';
